export enum TipoLivroEnum {

  Anual = "Anual",
  Mensal = "Mensal"
}
